<template>
  <div class="reports-dashboard">
      <h2>Ventas</h2>
    <div class="container mt-5 mb-5">
      <div class="row">
        <div class="col-md-4 mt-4 mb-4" v-for="report in reports" :key="report.id">
          <router-link
            :to="{ name: report.router_link, params: {marca: report.title, id_provider: report.id_provider } }"
            class="card-adela-anchor"
          >
            <div class="card-adela-item card-adela-diseno">
              <div class="card-adela-badge" style="background-color:#513692">
                <font-awesome-icon :icon="['fa', report.icon]" />
              </div>
              <div class="card-adela-category">
                <h2>{{ report.title }}</h2>
                <span>{{ report.description }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'

export default {
  mixins: [formatData],
  data () {
    return {
      reports: [
        {
          id: 1,
          icon: 'plus',
          title: 'Nueva venta',
          description: 'Buscar o generar reporte de inventario general.',
          router_link: 'addsales',
          subject: 'GeneralReport'
        }
        // {
        //   id: 2,
        //   icon: 'funnel-dollar',
        //   title: 'Reporte de ventas',
        //   description: 'Genera reporte de inventario por proveedor.',
        //   router_link: 'salesList',
        //   subject: 'GeneralReport'
        // }
        // {
        //   id: 3,
        //   icon: 'tshirt',
        //   title: 'Producto',
        //   description: 'Genera reporte de inventario por producto.',
        //   router_link: 'stocktakingList',
        //   subject: 'GeneralReport'
        // }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async getProviders () {
      try {
        const items = {
          function: 'getOrdersForProvider',
          status: 1, // status de pedido por marca
          enterprise_id: this.user.enterprise_id
        }
        const params = await this.toFormData(items)
        const response = await axiosAdelaService.post('', params)
        console.log('', response)
        if (response.status === 200) {
          if (response.data.totalRecords > 0) {
            response.data.provider.forEach(marca => {
              console.log('marca PXPXPXDD', marca)
              const idNext = this.reports.length + 1
              if (marca !== '') {
                this.reports.push({
                  id: idNext,
                  icon: 'chart-bar',
                  id_provider: marca.id_provider,
                  title: marca.name,
                  type: marca.name,
                  description: `Todos los pedidos de la marca ${marca.name}.`,
                  router_link: 'ordersList',
                  subject: 'GeneralReport'
                })
              }
            })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    }
  },
  mounted () {
    // this.getProviders()
  }
}
</script>
